export function drawBeadCellVisual(
  ctx: CanvasRenderingContext2D,
  options: {
    x: number
    y: number
    size: number
    fill: string
    isExternal?: boolean
    showGrid?: boolean
    beadStyle?: 'square' | 'tube'
    simpleExternal?: boolean
    outlineColor?: string
    outlineWidth?: number
  },
) {
  const {
    x,
    y,
    size,
    fill,
    isExternal = false,
    showGrid = false,
    beadStyle = 'square',
    simpleExternal = false,
  } = options
  const useGapGrid = showGrid && size >= 3
  const tileSize = useGapGrid ? size - 1 : size
  const tileX = x
  const tileY = y
  const gapColor = '#d5d1cb'

  if (isExternal) {
    if (useGapGrid) {
      ctx.fillStyle = '#d8d8d8'
      ctx.fillRect(tileX, tileY, size, size)
    }
    ctx.fillStyle = '#e8e8e8'
    ctx.fillRect(tileX, tileY, tileSize, tileSize)
    if (!simpleExternal && tileSize >= 6) {
      ctx.strokeStyle = 'rgba(0,0,0,0.06)'
      ctx.lineWidth = 1
      const step = Math.max(4, Math.floor(tileSize / 3))
      for (let i = -tileSize; i < tileSize * 2; i += step) {
        ctx.beginPath()
        ctx.moveTo(tileX + i, tileY)
        ctx.lineTo(tileX + i + tileSize, tileY + tileSize)
        ctx.stroke()
      }
    }
    return
  }

  if (useGapGrid) {
    ctx.fillStyle = gapColor
    ctx.fillRect(tileX, tileY, size, size)
  }

  if (beadStyle === 'square') {
    ctx.fillStyle = fill
    ctx.fillRect(tileX, tileY, tileSize, tileSize)
    if (options.outlineColor) {
      ctx.strokeStyle = options.outlineColor
      ctx.lineWidth = options.outlineWidth ?? 1
      ctx.strokeRect(tileX, tileY, tileSize, tileSize)
    } else if (showGrid && !useGapGrid) {
      ctx.strokeStyle = 'rgba(0,0,0,0.1)'
      ctx.lineWidth = 1
      ctx.strokeRect(tileX + 0.5, tileY + 0.5, Math.max(0, size - 1), Math.max(0, size - 1))
    }
    return
  }

  const inset = tileSize >= 8 ? 0.5 : 0
  const beadSize = Math.max(1, tileSize - inset * 2)
  const radius = beadSize / 2
  const cx = tileX + inset + radius
  const cy = tileY + inset + radius
  const holeRadius = beadSize >= 5 ? radius * 0.38 : 0

  ctx.fillStyle = fill
  ctx.beginPath()
  ctx.arc(cx, cy, radius, 0, Math.PI * 2)
  if (holeRadius > 0) {
    ctx.arc(cx, cy, holeRadius, 0, Math.PI * 2, true)
    ctx.fill('evenodd')
  } else {
    ctx.fill()
  }

  if (options.outlineColor) {
    ctx.strokeStyle = options.outlineColor
    ctx.lineWidth = options.outlineWidth ?? 1
    ctx.beginPath()
    ctx.arc(cx, cy, Math.max(0.5, radius - ctx.lineWidth * 0.5), 0, Math.PI * 2)
    ctx.stroke()
  }
}
